/* eslint-disable @typescript-eslint/no-var-requires */
// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'appNameTitle',
    appNameShort: 'UDEA',
    appLogo: require('@src/assets/images/logo/udea-main-logo-en.svg').default,
    appLogoCoventry: require('@src/assets/images/logo/coventry-dark.png').default,
    appLogoLight: require('@src/assets/images/logo/udea-main-logo-en-white.svg').default,
    appLogoLightCoventry: require('@src/assets/images/logo/coventry-light.png').default,
    appLogoImage: require('@src/assets/images/logo/udea-main-logo-en.svg').default,
    loginBgImage: require('@src/assets/images/bg/coventry-bg.jpg').default,
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
  loader: {
    logo: require('@src/assets/images/logo/udea-main-logo-en.svg').default,
    color: '#f8f8f8',
    logoDark: require('@src/assets/images/logo/udea-main-logo-en.svg').default,
    colorDark: '#161d31',
  },
}

export default themeConfig
